import React from "react";

const UserStatCard = ({ title, value, icon, color }) => (
  <div className="relative h-24 rounded-xl bg-white shadow-sm hover:shadow-lg transition-all duration-300 group overflow-hidden">
    {/* Gradient accent */}
    <div
      className={`absolute top-0 left-0 w-full h-1 bg-gradient-to-r ${color}`}
    />

    <div className="h-full px-4 flex items-center justify-between">
      {/* Left */}
      <div>
        <p className="text-xs text-gray-500 font-medium">{title}</p>
        <p className="text-2xl font-bold text-gray-800">{value}</p>
      </div>

      {/* Icon */}
      <div
        className={`text-xl text-white p-3 rounded-lg bg-gradient-to-br ${color}
        transform group-hover:scale-110 transition`}
      >
        {icon}
      </div>
    </div>
  </div>
);

export default UserStatCard;
